/**
 * @module source/helpers/addViewportFitCover
 *
 * Добавляет в мета-тег viewport параметр viewport-fit=cover
 * Это нужно для корректного отображения на iOS устройствах с вырезами в экране
 * @returns {void}
 */
export default () => {
  // Проверяем, что мета-тег viewport существует
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) { return; }

  // Проверяем, что параметр viewport-fit уже не установлен
  const content = meta.getAttribute('content') || '';
  if (/\bviewport-fit\s*=\s*cover\b/i.test(content)) { return; }

  // Добавляем параметр viewport-fit=cover, если его нет
  const updated = content.trim() ? `${content.trim()}, viewport-fit=cover` : 'viewport-fit=cover';

  meta.setAttribute('content', updated);
};
